var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.919,
    height: 21.613,
    viewBox: "0 0 26.919 21.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260.03 -5257.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1255.07,5257.333h-3.058a1.905,1.905,0,0,0-1.9,1.9v3.057a1.905,1.905,0,0,0,1.9,1.9h3.058a1.905,1.905,0,0,0,1.9-1.9v-3.057A1.905,1.905,0,0,0-1255.07,5257.333Zm.5,4.96a.5.5,0,0,1-.5.5h-3.058a.5.5,0,0,1-.5-.5v-3.057a.507.507,0,0,1,.5-.5h3.058a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1255.07,5264.695h-3.058a1.9,1.9,0,0,0-1.9,1.9v3.058a1.9,1.9,0,0,0,1.9,1.9h3.058a1.9,1.9,0,0,0,1.9-1.9V5266.6A1.9,1.9,0,0,0-1255.07,5264.695Zm.5,4.96a.5.5,0,0,1-.5.5h-3.058a.5.5,0,0,1-.5-.5V5266.6a.508.508,0,0,1,.5-.5h3.058a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1255.07,5272.014h-3.058a1.905,1.905,0,0,0-1.9,1.9v3.057a1.9,1.9,0,0,0,1.9,1.9h3.058a1.9,1.9,0,0,0,1.9-1.9v-3.057A1.905,1.905,0,0,0-1255.07,5272.014Zm.5,4.96a.5.5,0,0,1-.5.5h-3.058a.5.5,0,0,1-.5-.5v-3.057a.507.507,0,0,1,.5-.5h3.058a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1233.773,5268.247h-3.428a.663.663,0,0,0-.468.194l-5.948,5.948a.667.667,0,0,0-.194.468.658.658,0,0,0,.194.468l3.428,3.428a.655.655,0,0,0,.468.193.667.667,0,0,0,.469-.193l5.947-5.948a.658.658,0,0,0,.194-.468v-3.427A.663.663,0,0,0-1233.773,5268.247Zm-.664,3.816-5.284,5.285-2.49-2.491,5.285-5.285h2.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.768,
    cy: 0.768,
    r: 0.768,
    transform: "translate(-1236.911 5270.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5260.134h13.75a.687.687,0,0,0,.688-.688.687.687,0,0,0-.688-.687h-13.75a.688.688,0,0,0-.687.687A.687.687,0,0,0-1250.572,5260.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5262.455h6.875a.688.688,0,0,0,.688-.688.687.687,0,0,0-.688-.687h-6.875a.687.687,0,0,0-.687.687A.688.688,0,0,0-1250.572,5262.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5267.652h13.75a.686.686,0,0,0,.688-.687.687.687,0,0,0-.688-.688h-13.75a.688.688,0,0,0-.687.688A.687.687,0,0,0-1250.572,5267.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.572,5269.973h6.875a.687.687,0,0,0,.688-.687.687.687,0,0,0-.688-.688h-6.875a.687.687,0,0,0-.687.688A.688.688,0,0,0-1250.572,5269.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1243.96,5275.917h-6.875a.688.688,0,0,0-.688.688.688.688,0,0,0,.688.687h6.875a.687.687,0,0,0,.687-.687A.687.687,0,0,0-1243.96,5275.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1250.835,5274.972h5.761V5273.6h-5.761a.687.687,0,0,0-.688.687A.688.688,0,0,0-1250.835,5274.972Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.11039bb7dc871cd055ff99e9b5399505.svg";
export { ForwardRef as ReactComponent };